import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../util/AppContext';
import PropType from 'prop-types';
import { getConfigValue } from '../../util/getConfigValue';

ReportTimePeriodDropDown.propTypes = {
    isMenuVisible: PropType.bool,
    setIsMenuVisible: PropType.func,
    isEnabled: PropType.bool,
    menuContentRef: PropType.object,
    menuRef: PropType.object,
    setFilterState: PropType.func,
    filterState: PropType.object
}

function ReportTimePeriodDropDown(props) {
    const {
        isMenuVisible,
        setIsMenuVisible,  
        isEnabled,     
        menuContentRef,
        menuRef,
        setFilterState,
        filterState,
    } = props;

    const [timePeriodOptions, setTimePeriodOptions] = useState({});
    const [appState] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedLabel, setSelectedLabel] = useState(getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.SelectTimePeriod?.Label, appState)?.Value || null);

    useEffect(() => {
        const options = getTimePeriodOptions();
        setTimePeriodOptions(options);
        const defaultValue = appState?.config?.UtilizationDashboard?.Filter?.Timeperiod?.Default?.Value;

        const defaultTimePeriod = options.find((e) => e.Title === defaultValue);
        setFilterState({ ...filterState, timePeriodId: parseInt(defaultTimePeriod.DataField), timePeriodTitle: defaultTimePeriod.Title });
        setSelectedLabel(defaultTimePeriod.Title);
        setIsLoading(false);
     
    }, [appState.config]);

 
    function getTimePeriodOptions() {
         return appState?.config?.UtilizationDashboard?.Filter?.Timeperiod?.Options?.Columns
                .sort(function (a, b) { return a.Order - b.Order });
    }

    function getTimePeriodValue(item) {
        let selectedItem = timePeriodOptions.find((e) => e.DataField === item);
        setSelectedLabel(selectedItem.Title);
        return parseInt(selectedItem.DataField);
    }

 
    if(isLoading){
        return (<div className='p-5'>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</div>);
    }
    return (
        <div className=" mb-4 my-lg-0">
            <button
                disabled={!isEnabled}
                ref={menuRef}
                onClick={() => setIsMenuVisible(isMenuVisible => !isMenuVisible)}
                aria-expanded={isMenuVisible ? "true" : "false"}
                className="border-0 px-0 bg-transparent text-start d-block"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside">
                <div
                    className={!isEnabled ? "p-3 opacity-50" : "p-3"}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <span className="type-20 type-bold me-2">{selectedLabel}</span>
                        </div>
                        <span className="fa-solid fa-chevron-down"></span>
                    </div>
                </div>
            </button>
            <div
                ref={menuContentRef}
                className="dropdown-rc-options"
                id="dropdown-rc-options">  
                <div className={`dropdown-menu dropdown-menu-end ${isMenuVisible ? "show" : " "}`}>          
                    {
                         timePeriodOptions.map((item, index) => {
                            return (
                                <button
                                key={parseInt(item.DataField)}
                                
                                value={item.DataField}
                                label={item.Title}
                                className="border-0 px-0 bg-transparent text-start d-block w-100"
                                onClick={(e) => {setFilterState({ ...filterState, timePeriodId: getTimePeriodValue(item.DataField), timePeriodTitle: item.Title });  setIsMenuVisible(false);}}
                                >
                                <div className="p-2 px-5"
                                onMouseEnter={(e) => e.currentTarget.classList.add("bg-light")}
                                onMouseLeave={(e) => e.currentTarget.classList.remove("bg-light")}
                                >
                                    <p className="my-0 color-grey-dark-2 type-18">{item.Title}</p>
                                </div>
                                </button>
                            )                       
                        }) 
                    }
                </div>  
            </div>
        </div>
    );
}

export default ReportTimePeriodDropDown;